import { render, staticRenderFns } from "./EditCourseDialog.vue?vue&type=template&id=781d25ca"
import script from "./EditCourseDialog.vue?vue&type=script&lang=ts"
export * from "./EditCourseDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports